import { GameManager } from "../GameManager";

export class BootScene extends Phaser.Scene {

    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.image("catafractum-logo", "assets/catafractum-logo.png");
    }

    public create(): void {
        GameManager.setCurrentScene(this);
        GameManager.init();
    }
}
